import { render, staticRenderFns } from "./award.vue?vue&type=template&id=78bff306&scoped=true"
import script from "./award.vue?vue&type=script&lang=js"
export * from "./award.vue?vue&type=script&lang=js"
import style0 from "./award.vue?vue&type=style&index=0&id=78bff306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bff306",
  null
  
)

export default component.exports